// CONSTANTS are all caps.
const NS = 'ServicesBlockRL';
const CLS = 'servicesBlockRL';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/portalProfileDropdown.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class ServicesBlockRL {
	constructor(el) {
		// $el is the widget node return by the TopStickyNav function
		this.$html = $('html');

		this.$el = $(el);
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderItem = this.$el.find(`.${CLS}-slider-container`);

		this.autoplaySpeed = this.$el.data('autoplay-speed') || 3000;
		this.autoplayOption = this.$el.data('autoplay') || false;
	}

	init() {
		const slickOptions = {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: this.autoplayOption,
			autoplaySpeed: this.autoplaySpeed,
			mobileFirst: true,
			dots: true,
			infinite: true,
			dotsClass: `${CLS}-slider-dots`,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
			],
		};
		this.$slider.slick(slickOptions);
		this.$sliderItem.parent().addClass(`${CLS}-slider-item-parent`);
	}
}
